"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFileLike = exports.FileModule = exports.UPLOADER_POLLING_RATE_IN_MILLISECONDS = exports.CHUNKS_CONCURRENCY = exports.MINIMAL_CHUNK_SIZE_IN_BYTES = exports.DEFAULT_CHUNK_SIZE_IN_BYTES = exports.BYTES_IN_MB = exports.DEFAULT_FILE_TYPE = void 0;
const p_queue_1 = __importStar(require("@esm2cjs/p-queue"));
const crypto_1 = require("@akord/crypto");
const service_1 = require("./service/service");
const constants_1 = require("../constants");
const api_client_1 = require("../api/api-client");
const contract_1 = require("../types/contract");
const udl_1 = require("./udl");
const bad_request_1 = require("../errors/bad-request");
const stream_converter_1 = require("../util/stream-converter");
const types_1 = require("../types");
const query_options_1 = require("../types/query-options");
const common_1 = require("./common");
const platform_1 = require("../util/platform");
const mime_types_1 = require("../util/mime-types");
exports.DEFAULT_FILE_TYPE = "text/plain";
exports.BYTES_IN_MB = 1000000;
exports.DEFAULT_CHUNK_SIZE_IN_BYTES = 10 * exports.BYTES_IN_MB;
exports.MINIMAL_CHUNK_SIZE_IN_BYTES = 5 * exports.BYTES_IN_MB;
exports.CHUNKS_CONCURRENCY = 25;
exports.UPLOADER_POLLING_RATE_IN_MILLISECONDS = 2500;
class FileModule {
    constructor(wallet, api, service, contentType, overridedName) {
        this.contentType = null;
        this.service = new service_1.Service(wallet, api, service);
        this.contentType = contentType;
        this.overridedName = overridedName;
    }
    /**
     * @param  {ListFileOptions} options
     * @returns Promise with list of files per query options
     */
    list(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, query_options_1.validateListPaginatedApiOptions)(options);
            const { items, nextToken } = yield this.service.api.getFiles(options);
            return {
                items: items === null || items === void 0 ? void 0 : items.map((item) => new types_1.FileVersion(item)),
                nextToken: nextToken
            };
        });
    }
    /**
     * @param  {ListFileOptions} options
     * @returns Promise with list of all files per query options
     */
    listAll(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const list = (listOptions) => __awaiter(this, void 0, void 0, function* () {
                return yield this.list(listOptions);
            });
            return yield (0, common_1.paginate)(list, options);
        });
    }
    create(file, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            options.public = this.service.isPublic;
            const chunkSize = (_a = options.chunkSize) !== null && _a !== void 0 ? _a : exports.DEFAULT_CHUNK_SIZE_IN_BYTES;
            if (chunkSize < exports.MINIMAL_CHUNK_SIZE_IN_BYTES) {
                throw new bad_request_1.BadRequest("Chunk size can not be smaller than: " + exports.MINIMAL_CHUNK_SIZE_IN_BYTES / exports.BYTES_IN_MB);
            }
            if (file.size > chunkSize) {
                options.chunkSize = chunkSize;
                const tags = this.getFileTags(file, options);
                return yield this.uploadChunked(file, tags, options);
            }
            else {
                const tags = this.getFileTags(file, options);
                return yield this.upload(file, tags, options);
            }
        });
    }
    newVersion(file, uploadResult) {
        return __awaiter(this, void 0, void 0, function* () {
            const version = new types_1.FileVersion({
                owner: yield this.service.wallet.getAddress(),
                createdAt: JSON.stringify(Date.now()),
                name: yield this.service.processWriteString(this.overridedName || file.name),
                type: file.type,
                size: file.size,
                resourceUri: uploadResult.resourceUri,
                numberOfChunks: uploadResult.numberOfChunks,
                chunkSize: uploadResult.chunkSize,
                udl: uploadResult.udl,
                ucm: uploadResult.ucm
            });
            return version;
        });
    }
    download(fileUri, options = { responseType: 'arraybuffer' }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const file = yield this.service.api.downloadFile(fileUri, { responseType: 'stream', public: this.service.isPublic });
            let stream;
            if (this.service.isPublic) {
                stream = file.fileData;
            }
            else {
                const encryptedKey = file.metadata.encryptedKey;
                const iv = (_a = file.metadata.iv) === null || _a === void 0 ? void 0 : _a.split(',');
                const streamChunkSize = options.chunkSize ? options.chunkSize + crypto_1.AUTH_TAG_LENGTH_IN_BYTES + (iv ? 0 : crypto_1.IV_LENGTH_IN_BYTES) : null;
                stream = yield this.service.dataEncrypter.decryptStream(file.fileData, encryptedKey, streamChunkSize, iv);
            }
            if (options.responseType === 'arraybuffer') {
                return yield stream_converter_1.StreamConverter.toArrayBuffer(stream);
            }
            return stream;
        });
    }
    upload(file, tags, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const isPublic = options.public || this.service.isPublic;
            let encryptedKey;
            const { processedData, encryptionTags } = yield this.service.processWriteRaw(yield file.arrayBuffer(), { prefixCiphertextWithIv: true, encode: false });
            const resourceHash = yield (0, crypto_1.digestRaw)(new Uint8Array(processedData));
            const fileSignatureTags = yield this.getFileSignatureTags(resourceHash);
            const resource = yield this.service.api.uploadFile(processedData, tags.concat(encryptionTags).concat(fileSignatureTags), options);
            const resourceUri = resource.resourceUri;
            resourceUri.push(`hash:${resourceHash}`);
            if (!isPublic) {
                encryptedKey = encryptionTags.find((tag) => tag.name === constants_1.encryptionTags.ENCRYPTED_KEY).value;
            }
            return {
                resourceUri: resourceUri,
                resourceHash: resourceHash,
                encryptedKey: encryptedKey,
                udl: (0, udl_1.formatUDL)(options.udl),
                ucm: options.ucm
            };
        });
    }
    uploadChunked(file, tags, options) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const isPublic = options.public || this.service.isPublic;
            const chunkSize = options.chunkSize || exports.DEFAULT_CHUNK_SIZE_IN_BYTES;
            const chunkSizeWithNonceAndIv = isPublic ? chunkSize : chunkSize + crypto_1.AUTH_TAG_LENGTH_IN_BYTES + crypto_1.IV_LENGTH_IN_BYTES;
            const numberOfChunks = Math.ceil(file.size / chunkSize);
            const fileSize = isPublic ? file.size : file.size + numberOfChunks * (crypto_1.AUTH_TAG_LENGTH_IN_BYTES + crypto_1.IV_LENGTH_IN_BYTES);
            this.client = new api_client_1.ApiClient()
                .env(this.service.api.config)
                .public(this.service.isPublic)
                .tags(tags)
                .storage(options.storage)
                .numberOfChunks(numberOfChunks)
                .totalBytes(fileSize)
                .progressHook(options.progressHook)
                .cancelHook(options.cancelHook);
            const digestObject = (0, crypto_1.initDigest)();
            // upload the first chunk
            const chunkedResource = yield this.uploadChunk(file, chunkSize, 0, { digestObject, tags: tags });
            const resourceChunkSize = chunkedResource.resourceSize;
            const encryptedKey = (_a = chunkedResource.tags.find((tag) => tag.name === constants_1.encryptionTags.ENCRYPTED_KEY)) === null || _a === void 0 ? void 0 : _a.value;
            // upload the chunks in parallel
            let sourceOffset = chunkSize;
            let targetOffset = resourceChunkSize;
            const chunksQ = new p_queue_1.default({ concurrency: exports.CHUNKS_CONCURRENCY });
            const chunks = [];
            while (sourceOffset + chunkSize < file.size) {
                const localSourceOffset = sourceOffset;
                const localTargetOffset = targetOffset;
                chunks.push(() => this.uploadChunk(file, chunkSize, localSourceOffset, { digestObject, encryptedKey, targetOffset: localTargetOffset, location: chunkedResource.resourceLocation }));
                sourceOffset += chunkSize;
                targetOffset += resourceChunkSize;
            }
            try {
                yield chunksQ.addAll(chunks, { signal: (_b = options.cancelHook) === null || _b === void 0 ? void 0 : _b.signal });
            }
            catch (error) {
                if (!(error instanceof p_queue_1.AbortError) && !((_d = (_c = options.cancelHook) === null || _c === void 0 ? void 0 : _c.signal) === null || _d === void 0 ? void 0 : _d.aborted)) {
                    throw error;
                }
            }
            if ((_f = (_e = options.cancelHook) === null || _e === void 0 ? void 0 : _e.signal) === null || _f === void 0 ? void 0 : _f.aborted) {
                throw new p_queue_1.AbortError();
            }
            // upload the last chunk
            const resourceHash = digestObject.getHash("B64");
            const fileSignatureTags = yield this.getFileSignatureTags(resourceHash);
            const fileTags = tags.concat(fileSignatureTags);
            const resource = yield this.uploadChunk(file, chunkSize, sourceOffset, { digestObject, encryptedKey, targetOffset, tags: fileTags, location: chunkedResource.resourceLocation });
            // polling loop
            if (!options.cloud) {
                const uri = chunkedResource.resourceLocation.split(":")[0];
                while (true) {
                    yield new Promise(resolve => setTimeout(resolve, exports.UPLOADER_POLLING_RATE_IN_MILLISECONDS));
                    const state = yield this.service.api.getUploadState(uri);
                    if (state && state.resourceUri) {
                        resource.resourceUri = state.resourceUri;
                        break;
                    }
                }
            }
            return {
                resourceUri: resource.resourceUri,
                numberOfChunks: numberOfChunks,
                chunkSize: chunkSizeWithNonceAndIv,
                encryptedKey: encryptedKey,
                resourceHash: resourceHash,
                udl: (0, udl_1.formatUDL)(options.udl),
                ucm: options.ucm
            };
        });
    }
    uploadChunk(file, chunkSize = exports.DEFAULT_CHUNK_SIZE_IN_BYTES, offset = 0, options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const chunk = file.slice(offset, offset + chunkSize);
            const arrayBuffer = yield chunk.arrayBuffer();
            const data = yield this.service.processWriteRaw(arrayBuffer, { encryptedKey: options.encryptedKey, prefixCiphertextWithIv: true, encode: false });
            if (options.digestObject) {
                options.digestObject.update(new Uint8Array(data.processedData));
            }
            const loadedBytes = (_a = options.targetOffset) !== null && _a !== void 0 ? _a : offset;
            const client = this.client
                .clone()
                .data(data.processedData)
                .loadedBytes(loadedBytes);
            if (options.location) {
                client.resourceId(options.location);
            }
            if (options.tags && options.tags.length > 0) {
                client.tags([...options.tags, ...data.encryptionTags]);
            }
            const res = yield client.uploadFile();
            return Object.assign(Object.assign({}, res), { tags: data.encryptionTags });
        });
    }
    getFileTags(file, options = {}) {
        var _a;
        const tags = [];
        if (this.service.isPublic) {
            tags.push(new contract_1.Tag(constants_1.fileTags.FILE_NAME, this.overridedName || file.name));
            if (file.lastModified) {
                tags.push(new contract_1.Tag(constants_1.fileTags.FILE_MODIFIED_AT, file.lastModified.toString()));
            }
        }
        tags.push(new contract_1.Tag(constants_1.fileTags.FILE_SIZE, file.size));
        tags.push(new contract_1.Tag(constants_1.fileTags.FILE_TYPE, file.type || exports.DEFAULT_FILE_TYPE));
        if (options.chunkSize) {
            tags.push(new contract_1.Tag(constants_1.fileTags.FILE_CHUNK_SIZE, options.chunkSize));
        }
        tags.push(new contract_1.Tag(constants_1.smartweaveTags.CONTENT_TYPE, this.contentType || file.type || exports.DEFAULT_FILE_TYPE));
        tags.push(new contract_1.Tag(constants_1.protocolTags.TIMESTAMP, JSON.stringify(Date.now())));
        tags.push(new contract_1.Tag(constants_1.dataTags.DATA_TYPE, "File"));
        tags.push(new contract_1.Tag(constants_1.protocolTags.VAULT_ID, this.service.vaultId));
        if (this.service.parentId) {
            tags.push(new contract_1.Tag(constants_1.protocolTags.PARENT_ID, this.service.parentId));
        }
        (_a = options.arweaveTags) === null || _a === void 0 ? void 0 : _a.map((tag) => tags.push(tag));
        if (options.udl) {
            const udlTags = (0, udl_1.udlToTags)(options.udl);
            tags.push(...udlTags);
        }
        return tags;
    }
    getFileSignatureTags(resourceHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const privateKeyRaw = this.service.wallet.signingPrivateKeyRaw();
            const signature = yield (0, crypto_1.signHash)((0, crypto_1.base64ToArray)(resourceHash), privateKeyRaw);
            return [
                new contract_1.Tag(constants_1.protocolTags.SIGNER_ADDRESS, yield this.service.wallet.getAddress()),
                new contract_1.Tag(constants_1.protocolTags.SIGNATURE, signature),
                new contract_1.Tag(constants_1.fileTags.FILE_HASH, resourceHash)
            ];
        });
    }
}
exports.FileModule = FileModule;
;
function createFileLike(source, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const name = options.name || source.name;
        if (!(0, platform_1.isServer)()) {
            if (source instanceof File) {
                return source;
            }
            if (!name) {
                throw new bad_request_1.BadRequest("File name is required, please provide it in the file options.");
            }
            const mimeType = options.mimeType || (0, mime_types_1.getMimeTypeFromFileName)(name);
            if (!mimeType) {
                console.warn("Missing file mime type. If this is unintentional, please provide it in the file options.");
            }
            if (source instanceof Uint8Array || source instanceof ArrayBuffer || source instanceof Blob) {
                return new File([source], name, { type: mimeType, lastModified: options.lastModified });
            }
            else if (source instanceof Array) {
                return new File(source, name, { type: mimeType, lastModified: options.lastModified });
            }
        }
        else {
            const nodeJsFile = (yield Promise.resolve().then(() => __importStar(require("../types/file")))).NodeJs.File;
            if (typeof (source === null || source === void 0 ? void 0 : source.read) === 'function') {
                return nodeJsFile.fromReadable(source, name, options.mimeType, options.lastModified);
            }
            else if (source instanceof Uint8Array || source instanceof Buffer || source instanceof ArrayBuffer) {
                return new nodeJsFile([source], name, options.mimeType, options.lastModified);
            }
            else if (source instanceof nodeJsFile) {
                return source;
            }
            else if (typeof source === "string") {
                return nodeJsFile.fromPath(source, name, options.mimeType, options.lastModified);
            }
            else if (source instanceof Array) {
                return new nodeJsFile(source, name, options.mimeType, options.lastModified);
            }
        }
        throw new bad_request_1.BadRequest("File source is not supported. Please provide a valid source: web File object, file path, buffer or stream.");
    });
}
exports.createFileLike = createFileLike;
